import { Box } from '@mui/material';

import type { EventMarket, EventOutcome, EventResponse, Market, Outcome, TradeTab } from '@/types';
import { isMarketResolved } from '@/utils';
import { ResolvedTradeView } from './ResolvedTradeView';
import { TradeAmountInput } from './TradeAmountInput';
import { TradeHeader } from './TradeHeader';
import { TradeSlider } from './TradeSlider';
import { TradeSummary } from './TradeSummary';

export interface MobileTradeContentProps {
  event: EventResponse;
  market: Market | EventMarket;
  outcome: Outcome | EventOutcome;
  onClose: () => void;
  amount: string;
  setAmount: (value: string) => void;
  sliderValue: number;
  onSliderChange: (value: number) => void;
  activeTab: TradeTab;
  setActiveTab: (tab: TradeTab) => void;
  price: number;
  onTrade: () => void;
  onQuickAdd: (value: number) => void;
  isSubmitting?: boolean;
  orderError?: { message: string } | null;
  isAuthenticated?: boolean;
  isReadyToTrade?: boolean;
  isInsufficientBalance?: boolean;
  isInputInvalid?: boolean;
  balance?: number;
  orderBook?: any;
}

export function MobileTradeContent({
  event,
  market,
  outcome,
  onClose,
  amount,
  setAmount,
  sliderValue,
  onSliderChange,
  activeTab,
  setActiveTab,
  price,
  onTrade,
  onQuickAdd,
  isSubmitting,
  orderError,
  isAuthenticated,
  isReadyToTrade,
  isInsufficientBalance,
  isInputInvalid,
  balance,
  orderBook,
}: MobileTradeContentProps) {
  const outcomeName = outcome.name || '-';

  const isResolved = isMarketResolved(market);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'transparent',
        color: 'text.primary',
        borderRadius: 0,
        overflow: 'hidden',
      }}
    >
      <TradeHeader event={event} market={market} outcome={outcome} onClose={onClose} />

      <Box sx={{ flex: 1, overflowY: 'auto', px: 0 }}>
        {isResolved ? (
          <ResolvedTradeView event={event} market={market} />
        ) : (
          <>
            <TradeAmountInput
              value={amount}
              onChange={setAmount}
              onQuickAdd={onQuickAdd}
              balance={balance}
            />

            <Box sx={{ mt: { xs: 1, sm: 2 }, px: 2 }}>
              <TradeSlider value={sliderValue} onChange={onSliderChange} />
            </Box>

            <TradeSummary
              price={price}
              activeTab={activeTab}
              onTrade={onTrade}
              outcomeName={outcomeName}
              amount={amount}
              isSubmitting={isSubmitting}
              isAuthenticated={isAuthenticated}
              isReadyToTrade={isReadyToTrade}
              isInsufficientBalance={isInsufficientBalance}
              isInputInvalid={isInputInvalid}
            />
          </>
        )}
      </Box>
    </Box>
  );
}
